import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding":"5px","background-color":"#FFF"} }

import { reactive, ref, onMounted, computed } from 'vue';
import { useRoute, useRouter } from "vue-router"
import tools from '@/tools'

import { useUserStore } from '@/store/user'
import request from '@/plugin/request'
import work from '@/plugin/work'

import { Toast } from 'vant';


export default /*#__PURE__*/_defineComponent({
  __name: 'product',
  setup(__props) {

const user = useUserStore()


const router = useRouter();

let product = reactive({
  list: [] as any[],
  keywords: '',
  pageNum: 1,
  pageSize: 20,
  totalCount: 0,
  change: (e: any) => {
    product.pageNum = e
    product.query()
  },
  query: () => {
    const body = { keywords: product.keywords, pageNum: product.pageNum, pageSize: product.pageSize }
    request('/work/func/product', body, { method: 'POST', loading: true }).then(res => {
      product.list = res.result.pageList
      product.pageNum = res.result.pageNum
      product.totalCount = res.result.totalCount
    })
  },
  search: {
    submit: () => {
      product.query()
    },
    cancel: () => {
      product.query()
    }
  },
  share: (item: any) => {
    request('/work/func/product/share', item, { method: 'POST', loading: true }).then(res => {

      const message = res.result

      work.wecom.invoke('sendChatMessage', {
        msgtype: "news", //消息类型，必填
        enterChat: true, //为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
        news: message
      }, (res: any) => {
        console.log(res)
      })


    })
  }
})

onMounted(async () => {

  // const params = tools.data.getUrlParams()

  await work.get_agent()

  work.check_agent()


  product.query()




})

const demo = () => {


}

return (_ctx: any,_cache: any) => {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_pagination = _resolveComponent("van-pagination")!
  const _component_van_card = _resolveComponent("van-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_search, {
      modelValue: _unref(product).keywords,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(product).keywords) = $event)),
      "show-action": "",
      label: "地址",
      placeholder: "请输入搜索关键词",
      onSearch: _unref(product).search.submit
    }, {
      action: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(product).search.submit && _unref(product).search.submit(...args)))
        }, "搜索")
      ]),
      _: 1
    }, 8, ["modelValue", "onSearch"]),
    _createVNode(_component_van_pagination, {
      modelValue: _unref(product).pageNum,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(product).pageNum) = $event)),
      "total-items": _unref(product).totalCount,
      "items-per-page": _unref(product).pageSize,
      onChange: _unref(product).change
    }, null, 8, ["modelValue", "total-items", "items-per-page", "onChange"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(product).list, (item) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_van_card, {
          num: item.avaliableStockNum,
          price: item.minPrice,
          desc: "",
          title: item.title,
          thumb: item.defaultImageUrl,
          onClick: ($event: any) => (_unref(product).share(item))
        }, null, 8, ["num", "price", "title", "thumb", "onClick"])
      ]))
    }), 256))
  ], 64))
}
}

})